<template>
  <div :class="{'empty': !checkId(model.id)}">
    <router-link v-if="checkId(model.id)" :to="'/users/' + model.id">{{model.name}}</router-link>
    <bread-item v-for="(item,i) in model.groups"
                :index="'child ' + i"
                :model="item"
                class="hierarchy-item"
                v-if="checkId(model.id)"
                :key="i + 'bread' + model.id"></bread-item>
  </div>
</template>

<script>
  import breadItem from './breadItem'
  import {tokenAndRoute} from "../../mixins/utils/tokenAndRoute";

  export default {
    name: 'breadItem',
    props: {
      model: {
        type: Object
      },
    },
    mixins: [tokenAndRoute],
    components: {
      breadItem
    },
    methods: {
      checkId(id) {
        return !(id == this.routeId);
      }
    }
  }
</script>

<style lang="scss" scoped>
  div {
    white-space: nowrap;
  }

  .hierarchy-item {
    min-height: 50px;
    justify-content: center;
    //box-shadow: 0px 1px 0px #F5F8FA;
    //padding: 0 20px;
    display: flex;
    /*align-items: center;*/
    flex-direction: column;


    a {
      font-family: $msb;
      font-size: 12px;
      letter-spacing: .15px;
      color: $darkBlue;
      transition: $anim;
    }

    &:last-of-type {
      box-shadow: none;
    }
  }

  .empty {
    min-height: 0px!important;
    max-height: 0px!important;
  }
</style>
